// Central lesson registry.
// Adds a new lesson by importing it once and dropping it into MAX_WEEKS.
//
// Public API kept stable so older imports
// (`import { WEEKS, findDay, computeDayStatus } from '../data/lessons'`)
// keep working without changes in any consuming page.

import day1 from './max/week-1/day-1';
import day2 from './max/week-1/day-2';
import maxWeek1Day3 from './max/week-1/day-3';
import maxWeek1Day4 from './max/week-1/day-4';
import maxWeek1Day5 from './max/week-1/day-5';
import maxWeek2Day1 from './max/week-2/day-1';
import maxWeek2Day2 from './max/week-2/day-2';
import maxWeek2Day3 from './max/week-2/day-3';
import maxWeek2Day4 from './max/week-2/day-4';
import maxWeek2Day5 from './max/week-2/day-5';
import maxWeek3Day1 from './max/week-3/day-1';
import maxWeek3Day2 from './max/week-3/day-2';
import maxWeek3Day3 from './max/week-3/day-3';
import maxWeek3Day4 from './max/week-3/day-4';
import maxWeek3Day5 from './max/week-3/day-5';
import maxWeek4Day1 from './max/week-4/day-1';
import maxWeek4Day2 from './max/week-4/day-2';
import maxWeek4Day3 from './max/week-4/day-3';
import maxWeek4Day4 from './max/week-4/day-4';
import maxWeek4Day5 from './max/week-4/day-5';
import maxWeek5Day1 from './max/week-5/day-1';
import maxWeek5Day2 from './max/week-5/day-2';
import maxWeek5Day3 from './max/week-5/day-3';
import maxWeek5Day4 from './max/week-5/day-4';
import maxWeek5Day5 from './max/week-5/day-5';
import maxWeek6Day1 from './max/week-6/day-1';
import maxWeek6Day2 from './max/week-6/day-2';
import maxWeek6Day3 from './max/week-6/day-3';
import maxWeek6Day4 from './max/week-6/day-4';
import maxWeek6Day5 from './max/week-6/day-5';
import maxWeek7Day1 from './max/week-7/day-1';
import maxWeek7Day2 from './max/week-7/day-2';
import maxWeek7Day3 from './max/week-7/day-3';
import maxWeek7Day4 from './max/week-7/day-4';
import maxWeek7Day5 from './max/week-7/day-5';
import maxWeek8Day1 from './max/week-8/day-1';
import maxWeek8Day2 from './max/week-8/day-2';
import maxWeek8Day3 from './max/week-8/day-3';
import maxWeek8Day4 from './max/week-8/day-4';
import maxWeek8Day5 from './max/week-8/day-5';
import maxWeek9Day1 from './max/week-9/day-1';
import maxWeek9Day2 from './max/week-9/day-2';
import maxWeek9Day3 from './max/week-9/day-3';
import maxWeek9Day4 from './max/week-9/day-4';
import maxWeek9Day5 from './max/week-9/day-5';
import maxWeek10Day1 from './max/week-10/day-1';
import maxWeek10Day2 from './max/week-10/day-2';
import maxWeek10Day3 from './max/week-10/day-3';
import maxWeek10Day4 from './max/week-10/day-4';
import maxWeek10Day5 from './max/week-10/day-5';

// ---------- Anita curriculum (Phase 1: Week 1 real) ----------
import anitaWeek1Day1 from './anita/week-1/day-1';
import anitaWeek1Day2 from './anita/week-1/day-2';
import anitaWeek1Day3 from './anita/week-1/day-3';
import anitaWeek1Day4 from './anita/week-1/day-4';
import anitaWeek1Day5 from './anita/week-1/day-5';
import anitaWeek2Day1 from './anita/week-2/day-1';
import anitaWeek2Day2 from './anita/week-2/day-2';
import anitaWeek2Day3 from './anita/week-2/day-3';
import anitaWeek2Day4 from './anita/week-2/day-4';
import anitaWeek2Day5 from './anita/week-2/day-5';
import anitaWeek3Day1 from './anita/week-3/day-1';
import anitaWeek3Day2 from './anita/week-3/day-2';
import anitaWeek3Day3 from './anita/week-3/day-3';
import anitaWeek3Day4 from './anita/week-3/day-4';
import anitaWeek3Day5 from './anita/week-3/day-5';
import anitaWeek4Day1 from './anita/week-4/day-1';
import anitaWeek4Day2 from './anita/week-4/day-2';
import anitaWeek4Day3 from './anita/week-4/day-3';
import anitaWeek4Day4 from './anita/week-4/day-4';
import anitaWeek4Day5 from './anita/week-4/day-5';
import anitaWeek5Day1 from './anita/week-5/day-1';
import anitaWeek5Day2 from './anita/week-5/day-2';
import anitaWeek5Day3 from './anita/week-5/day-3';
import anitaWeek5Day4 from './anita/week-5/day-4';
import anitaWeek5Day5 from './anita/week-5/day-5';
import anitaWeek6Day1 from './anita/week-6/day-1';
import anitaWeek6Day2 from './anita/week-6/day-2';
import anitaWeek6Day3 from './anita/week-6/day-3';
import anitaWeek6Day4 from './anita/week-6/day-4';
import anitaWeek6Day5 from './anita/week-6/day-5';
import anitaWeek7Day1 from './anita/week-7/day-1';
import anitaWeek7Day2 from './anita/week-7/day-2';
import anitaWeek7Day3 from './anita/week-7/day-3';
import anitaWeek7Day4 from './anita/week-7/day-4';
import anitaWeek7Day5 from './anita/week-7/day-5';
import anitaWeek8Day1 from './anita/week-8/day-1';
import anitaWeek8Day2 from './anita/week-8/day-2';
import anitaWeek8Day3 from './anita/week-8/day-3';
import anitaWeek8Day4 from './anita/week-8/day-4';
import anitaWeek8Day5 from './anita/week-8/day-5';
import anitaWeek9Day1 from './anita/week-9/day-1';
import anitaWeek9Day2 from './anita/week-9/day-2';
import anitaWeek9Day3 from './anita/week-9/day-3';
import anitaWeek9Day4 from './anita/week-9/day-4';
import anitaWeek9Day5 from './anita/week-9/day-5';
import anitaWeek10Day1 from './anita/week-10/day-1';
import anitaWeek10Day2 from './anita/week-10/day-2';
import anitaWeek10Day3 from './anita/week-10/day-3';
import anitaWeek10Day4 from './anita/week-10/day-4';
import anitaWeek10Day5 from './anita/week-10/day-5';

// ---------- Schema normalisers ----------
// New (v0.5+) lesson files use plain Russian strings.
// Old (Day 1-2) lesson files use { ru, en } bilingual maps.
// UI components consume the bilingual shape, so we wrap any plain string.
const isPlainObj = (v) => v && typeof v === 'object' && !Array.isArray(v);
const wrapStr = (v) => (typeof v === 'string' ? { ru: v, en: v } : v);
const wrapStrArr = (v) =>
  Array.isArray(v) && (v.length === 0 || typeof v[0] === 'string')
    ? { ru: v, en: v }
    : v;

// Normalise a single online task into the bilingual shape Lesson.jsx expects.
const normTask = (q) => {
  const out = { ...q };
  out.prompt = wrapStr(q.prompt);
  // hint may be either `hint`, `helper`, or `placeholder` in the new schema
  if (q.hint) out.hint = wrapStr(q.hint);
  else if (q.helper) out.hint = wrapStr(q.helper);
  else if (q.placeholder) out.hint = wrapStr(q.placeholder);

  if (Array.isArray(q.options)) {
    out.options = q.options.map((o) => ({ ...o, label: wrapStr(o.label) }));
  }
  if (Array.isArray(q.categories)) {
    out.categories = q.categories.map((c) => ({ ...c, label: wrapStr(c.label) }));
  }
  if (Array.isArray(q.items)) {
    out.items = q.items.map((it) => ({
      ...it,
      label: wrapStr(it.label || it.text)
    }));
  }
  if (q.unit) out.unit = wrapStr(q.unit);
  return out;
};

// Convert a v0.5+ printWorksheet (`pages: [{title, blocks: [...]}]`) into the
// flat tasks list Lesson.jsx / PrintWorksheet.jsx already render.
const flattenPrint = (pw) => {
  if (!pw) return null;
  if (pw.tasks) return pw; // already legacy

  const lines = [];
  for (const page of pw.pages || []) {
    if (page.title) lines.push(page.title);
    for (const block of page.blocks || []) {
      if (block.type === 'text' && block.text) lines.push(block.text);
      if (block.type === 'list' && Array.isArray(block.items)) {
        for (const item of block.items) lines.push(`  • ${item}`);
      }
    }
    lines.push('');
  }
  return {
    title: wrapStr([pw.title, pw.subtitle].filter(Boolean).join(' — ')),
    tasks: { ru: lines, en: lines }
  };
};

const flattenAnswerKey = (ak) => {
  if (ak == null) return undefined;
  if (typeof ak === 'string') return wrapStr(ak);
  if (Array.isArray(ak)) {
    const text = ak.map((row) => `${row.taskId}: ${row.answer}`).join('\n');
    return wrapStr(text);
  }
  return ak;
};

// Generic pass-through wrapper for optional bilingual fields.
// - `{ru,en}` objects are returned unchanged so `tx()` can pick a language.
// - Plain strings are wrapped to `{ru, en}` so `tx()` does not return ''.
// - Arrays of plain strings are wrapped to `{ru: arr, en: arr}`.
// - Anything else (number, null, undefined, structured object) is returned as-is.
const passThruBilingual = (v) => {
  if (v == null) return v;
  if (typeof v === 'string') return wrapStr(v);
  if (Array.isArray(v)) {
    if (v.length === 0 || typeof v[0] === 'string') return wrapStrArr(v);
    return v;
  }
  return v;
};

// Optional additive parentGuide fields supported on the UI side (Phase 0).
// Existing Max lessons may not provide any of these; if absent, the adapter
// emits `undefined` and the UI renders nothing extra.
const OPTIONAL_PARENT_GUIDE_KEYS = [
  'whatThisLessonTeaches',
  'keyMessage',
  'howToExplain',
  'exampleDialogue',
  'readingSupport',
  'russianSpeechGoal',
  'mathAnswerKey',
  'spellingAnswerKey',
  'drawingCriteria',
  'projectCriteria',
  'commonMistakes',
  'rewardGuidance',
  'parentOnlyNotes',
  'safetyNotes',
  'financeSafetyNotes',
  'rubric',
  // Structured Week-2 safety teaching block. Passes through as an object;
  // Lesson.jsx renders it inside the parent-only tab. Never shown to child.
  'parentTheoryCard'
];

const buildOptionalParentGuide = (pg) => {
  if (!pg) return {};
  const out = {};
  for (const k of OPTIONAL_PARENT_GUIDE_KEYS) {
    if (pg[k] != null) out[k] = passThruBilingual(pg[k]);
  }
  return out;
};

// ---------- Adapter: lesson module → legacy day shape ----------
const toLegacyDay = (lesson) => {
  const isNewSchema = typeof lesson.title === 'string';
  if (!isNewSchema) {
    // Old bilingual lesson — preserve as-is, only attach optional new fields.
    return {
      id: lesson.dayId,
      title: lesson.title,
      subtitle: lesson.subtitle,
      intro: lesson.nimnyIntro,
      online: lesson.onlineTasks,
      notebook: lesson.notebookInstructions,
      print: lesson.printWorksheet,
      parentGuide: {
        goal: lesson.parentGuide?.goal,
        check: lesson.parentGuide?.check,
        answers: lesson.answerKey,
        prompts: lesson.parentGuide?.prompts,
        ifEasy: lesson.parentGuide?.ifEasy,
        ifDifficult: lesson.parentGuide?.ifDifficult,
        // Phase 0: pass optional extended teaching-guidance fields through
        // unchanged (these were not used by Max Day 1/2 but the channel is
        // now open for any future content).
        ...buildOptionalParentGuide(lesson.parentGuide)
      },
      goals: lesson.goals,
      vocabulary: lesson.vocabulary,
      estimatedTimeLabel: lesson.estimatedTimeLabel,
      completionRequirements: lesson.completionRequirements,
      nextLessonId: lesson.nextLessonId,
      studentId: lesson.studentId,
      reward: lesson.reward,
      _content: lesson
    };
  }

  // New mono-Russian schema → wrap into bilingual.
  const goalsArr = Array.isArray(lesson.goals) ? lesson.goals : [];
  const vocab = Array.isArray(lesson.vocabulary)
    ? lesson.vocabulary.map((v) => ({
        term: wrapStr(v.term),
        meaning: wrapStr(v.definition || v.meaning || v.translation || '')
      }))
    : undefined;

  const notebookSteps = Array.isArray(lesson.notebookInstructions)
    ? lesson.notebookInstructions
    : isPlainObj(lesson.notebookInstructions)
    ? lesson.notebookInstructions.steps?.ru || []
    : [];

  return {
    id: lesson.dayId,
    title: wrapStr(lesson.title),
    subtitle: wrapStr(lesson.subtitle),
    intro: wrapStr(lesson.nimnyIntro),
    online: (lesson.onlineTasks || []).map(normTask),
    notebook: {
      title: wrapStr('Работа в тетради'),
      steps: { ru: notebookSteps, en: notebookSteps }
    },
    print: flattenPrint(lesson.printWorksheet),
    parentGuide: {
      goal: wrapStr(lesson.parentGuide?.goal),
      check: wrapStrArr(lesson.parentGuide?.check) ||
        wrapStr(lesson.parentGuide?.check),
      answers: flattenAnswerKey(
        lesson.parentGuide?.answerKey || lesson.answerKey
      ),
      prompts: wrapStrArr(lesson.parentGuide?.discussionPrompts) ||
        wrapStrArr(lesson.parentGuide?.prompts),
      ifEasy: wrapStr(lesson.parentGuide?.ifEasy),
      ifDifficult: wrapStr(lesson.parentGuide?.ifDifficult),
      // Phase 0: pass optional teaching-guidance fields through so Anita
      // lessons (and any future Max lessons) can render extended hints in
      // the parent tab without further schema migrations. Max lessons that
      // don't supply these fields render exactly as before.
      ...buildOptionalParentGuide(lesson.parentGuide)
    },
    goals: { ru: goalsArr, en: goalsArr },
    vocabulary: vocab,
    estimatedTimeLabel: wrapStr(lesson.estimatedTimeLabel),
    completionRequirements: lesson.completionRequirements,
    nextLessonId: lesson.nextLessonId,
    studentId: lesson.studentId,
    reward: lesson.reward,
    _content: lesson
  };
};

// ---------- Build WEEKS ----------
const week1Lessons = [day1, day2, maxWeek1Day3, maxWeek1Day4, maxWeek1Day5];
const week2Lessons = [maxWeek2Day1, maxWeek2Day2, maxWeek2Day3, maxWeek2Day4, maxWeek2Day5];
const week3Lessons = [maxWeek3Day1, maxWeek3Day2, maxWeek3Day3, maxWeek3Day4, maxWeek3Day5];
const week4Lessons = [maxWeek4Day1, maxWeek4Day2, maxWeek4Day3, maxWeek4Day4, maxWeek4Day5];
const week5Lessons = [maxWeek5Day1, maxWeek5Day2, maxWeek5Day3, maxWeek5Day4, maxWeek5Day5];
const week6Lessons = [maxWeek6Day1, maxWeek6Day2, maxWeek6Day3, maxWeek6Day4, maxWeek6Day5];
const week7Lessons = [maxWeek7Day1, maxWeek7Day2, maxWeek7Day3, maxWeek7Day4, maxWeek7Day5];
const week8Lessons = [maxWeek8Day1, maxWeek8Day2, maxWeek8Day3, maxWeek8Day4, maxWeek8Day5];
const week9Lessons = [maxWeek9Day1, maxWeek9Day2, maxWeek9Day3, maxWeek9Day4, maxWeek9Day5];
const week10Lessons = [maxWeek10Day1, maxWeek10Day2, maxWeek10Day3, maxWeek10Day4, maxWeek10Day5];

export const MAX_WEEKS = [
  {
    id: 'week-1',
    title: { ru: 'Деньги, счёт и безопасный выбор', en: 'Money, Account and Safe Choice' },
    subtitle: {
      ru: 'Монетки, баланс, маленький бюджет и первые правила безопасности',
      en: 'Coins, balance, a small budget and first safety rules'
    },
    days: week1Lessons.map(toLegacyDay)
  },
  {
    id: 'week-2',
    title: { ru: 'Щит Нимни: социальная безопасность', en: 'Nimny Safety Shield: Social Safety' },
    subtitle: { ru: 'Я знаю, что делать', en: 'I Know What To Do' },
    days: week2Lessons.map(toLegacyDay),
    // Week 2 unlocks once the previous week's last day is completed.
    unlockAfter: { weekId: 'week-1', dayId: 'day-5' }
  },
  {
    id: 'week-3',
    title: {
      ru: 'Измерения, движение и физика вокруг нас',
      en: 'Measurements, Movement and Physics Around Us'
    },
    days: week3Lessons.map(toLegacyDay),
    // Week 3 unlocks once Week 2 Day 5 is completed.
    unlockAfter: { weekId: 'week-2', dayId: 'day-5' }
  },
  {
    id: 'week-4',
    title: {
      ru: 'Карты, маршруты, масштаб и география',
      en: 'Maps, Routes, Scale and Geography'
    },
    days: week4Lessons.map(toLegacyDay),
    // Week 4 unlocks once Week 3 Day 5 is completed.
    unlockAfter: { weekId: 'week-3', dayId: 'day-5' }
  },
  {
    id: 'week-5',
    title: {
      ru: 'Поиск информации, источники и ИИ',
      en: 'Research, Sources and AI'
    },
    days: week5Lessons.map(toLegacyDay),
    // Week 5 unlocks once Week 4 Day 5 is completed.
    unlockAfter: { weekId: 'week-4', dayId: 'day-5' }
  },
  { id: 'week-6', title: { ru: 'Время, режим, здоровье и привычки', en: 'Time, Routine, Health and Habits' }, days: week6Lessons.map(toLegacyDay), unlockAfter: { weekId: 'week-5', dayId: 'day-5' } },
  { id: 'week-7', title: { ru: 'Профессии, работа, бизнес', en: 'Professions, Work and Business' }, days: week7Lessons.map(toLegacyDay), unlockAfter: { weekId: 'week-6', dayId: 'day-5' } },
  { id: 'week-8', title: { ru: 'Компании, риск, акции и инвестиции', en: 'Companies, Risk, Stocks and Investing' }, days: week8Lessons.map(toLegacyDay), unlockAfter: { weekId: 'week-7', dayId: 'day-5' } },
  { id: 'week-9', title: { ru: 'Информационный компас Нимни', en: 'Nimny Information Compass' }, subtitle: { ru: 'От пользователя к создателю', en: 'From User to Creator' }, days: week9Lessons.map(toLegacyDay), unlockAfter: { weekId: 'week-8', dayId: 'day-5' } },
  { id: 'week-10', title: { ru: 'Большая миссия Нимни', en: 'Nimny Final Quest' }, subtitle: { ru: 'Собери огоньки знаний и открой ночную игру', en: 'Collect the lights of knowledge and unlock the night game' }, days: week10Lessons.map(toLegacyDay), unlockAfter: { weekId: 'week-9', dayId: 'day-5' } }
];

// ---------- Build ANITA_WEEKS ----------
// Week 1: real (Days 1–5 authored by the curriculum author).
// Weeks 2–10: locked placeholders with the canonical Anita Week 1 theme
// extended into a sketch of the broader course arc — they show only a
// title in the UI and never expose any lessons. `locked: true` and
// `days: []` together ensure `computeDayStatus` returns 'locked' for any
// (weekId, dayId) query inside those weeks, so no Max content can ever
// be reached through Anita's course template.
const anitaWeek1Lessons = [
  anitaWeek1Day1,
  anitaWeek1Day2,
  anitaWeek1Day3,
  anitaWeek1Day4,
  anitaWeek1Day5
];

const anitaWeek2Lessons = [
  anitaWeek2Day1,
  anitaWeek2Day2,
  anitaWeek2Day3,
  anitaWeek2Day4,
  anitaWeek2Day5
];

const anitaWeek3Lessons = [
  anitaWeek3Day1,
  anitaWeek3Day2,
  anitaWeek3Day3,
  anitaWeek3Day4,
  anitaWeek3Day5
];

const anitaWeek4Lessons = [
  anitaWeek4Day1,
  anitaWeek4Day2,
  anitaWeek4Day3,
  anitaWeek4Day4,
  anitaWeek4Day5
];

const anitaWeek5Lessons = [
  anitaWeek5Day1,
  anitaWeek5Day2,
  anitaWeek5Day3,
  anitaWeek5Day4,
  anitaWeek5Day5
];

const anitaWeek6Lessons = [
  anitaWeek6Day1,
  anitaWeek6Day2,
  anitaWeek6Day3,
  anitaWeek6Day4,
  anitaWeek6Day5
];

const anitaWeek7Lessons = [
  anitaWeek7Day1,
  anitaWeek7Day2,
  anitaWeek7Day3,
  anitaWeek7Day4,
  anitaWeek7Day5
];

const anitaWeek8Lessons = [
  anitaWeek8Day1,
  anitaWeek8Day2,
  anitaWeek8Day3,
  anitaWeek8Day4,
  anitaWeek8Day5
];

const anitaWeek9Lessons = [
  anitaWeek9Day1,
  anitaWeek9Day2,
  anitaWeek9Day3,
  anitaWeek9Day4,
  anitaWeek9Day5
];

const anitaWeek10Lessons = [
  anitaWeek10Day1,
  anitaWeek10Day2,
  anitaWeek10Day3,
  anitaWeek10Day4,
  anitaWeek10Day5
];

export const ANITA_WEEKS = [
  {
    id: 'week-1',
    title: {
      ru: 'Деньги, ценность, накопление и первые инвестиции',
      en: 'Money, Value, Saving and First Investing Ideas'
    },
    subtitle: {
      ru: 'Деньги, выбор, польза, цель, накопление и риск',
      en: 'Money, choice, value, goal, saving and risk'
    },
    days: anitaWeek1Lessons.map(toLegacyDay)
  },
  {
    id: 'week-2',
    title: {
      ru: 'Время, измерения, данные, деньги и маленький физический опыт',
      en: 'Time, Measurements, Data, Money and a Small Physics Experiment'
    },
    subtitle: {
      ru: 'План дня, длина и периметр, таблицы, сдача и пляшущие конфетти',
      en: 'Day plan, length and perimeter, tables, change and dancing confetti'
    },
    days: anitaWeek2Lessons.map(toLegacyDay),
    unlockAfter: { weekId: 'week-1', dayId: 'day-5' }
  },
  {
    id: 'week-3',
    title: {
      ru: 'Лаборатория Нимни: измерения, движение, опыты и данные',
      en: 'Nimny Lab: Measurement, Motion, Experiments and Data'
    },
    subtitle: {
      ru: 'Измерения, движение, магниты, погода, данные и мини-отчёт',
      en: 'Measurement, motion, magnets, weather, data and mini lab report'
    },
    days: anitaWeek3Lessons.map(toLegacyDay),
    unlockAfter: { weekId: 'week-2', dayId: 'day-5' }
  },
  {
    id: 'week-4',
    title: {
      ru: 'География, земной шар, континенты, карты и безопасные маршруты',
      en: 'Geography, the Globe, Continents, Maps and Safe Routes'
    },
    subtitle: {
      ru: 'Земля, глобус, карта, компас, легенда, координаты и безопасный маршрут',
      en: 'Earth, globe, map, compass, legend, coordinates and a safe route'
    },
    days: anitaWeek4Lessons.map(toLegacyDay),
    unlockAfter: { weekId: 'week-3', dayId: 'day-5' }
  },
  {
    id: 'week-5',
    title: {
      ru: 'Источники, поиск, реклама и ИИ для ребёнка',
      en: 'Sources, Search, Advertising and AI for Kids'
    },
    subtitle: {
      ru: 'Источники, факт/мнение/фантазия, реклама, ИИ и проект «Мой надёжный ответ»',
      en: 'Sources, fact/opinion/fantasy, ads, AI and the "My Reliable Answer" project'
    },
    days: anitaWeek5Lessons.map(toLegacyDay),
    unlockAfter: { weekId: 'week-4', dayId: 'day-5' }
  },
  {
    id: 'week-6',
    title: {
      ru: 'Время, привычки, цели и самостоятельность',
      en: 'Time, Habits, Goals and Independence'
    },
    subtitle: {
      ru: 'Части дня, часы, расписание, привычки, цель и проект времени',
      en: 'Parts of the day, clock, schedule, habits, goal and a time project'
    },
    days: anitaWeek6Lessons.map(toLegacyDay),
    unlockAfter: { weekId: 'week-5', dayId: 'day-5' }
  },
  {
    id: 'week-7',
    title: {
      ru: 'Профессии, работа, польза и маленькая бизнес-идея',
      en: 'Professions, Work, Value and a Small Business Idea'
    },
    subtitle: {
      ru: 'Профессии, навыки, продукт и услуга, материалы, честная реклама и проект маленькой бизнес-идеи',
      en: 'Professions, skills, product and service, materials, honest advertising and a small business idea project'
    },
    days: anitaWeek7Lessons.map(toLegacyDay),
    unlockAfter: { weekId: 'week-6', dayId: 'day-5' }
  },
  {
    id: 'week-8',
    title: {
      ru: 'Животные, растения, природа и наблюдение мира',
      en: 'Animals, Plants, Nature and Observing the World'
    },
    subtitle: {
      ru: 'Живое и неживое, растения, животные, связи в природе и мини-атлас природы',
      en: 'Living vs non-living, plants, animals, nature connections and a mini nature atlas'
    },
    days: anitaWeek8Lessons.map(toLegacyDay),
    unlockAfter: { weekId: 'week-7', dayId: 'day-5' }
  },
  {
    id: 'week-9',
    title: {
      ru: 'Информационный компас Нимни',
      en: 'Nimny Information Compass'
    },
    subtitle: {
      ru: 'От пользователя к создателю',
      en: 'From User to Creator'
    },
    days: anitaWeek9Lessons.map(toLegacyDay),
    unlockAfter: { weekId: 'week-8', dayId: 'day-5' }
  },
  {
    id: 'week-10',
    title: {
      ru: 'Большая миссия Нимни',
      en: 'Nimny Final Quest'
    },
    subtitle: {
      ru: 'Собери огоньки знаний и открой ночную игру',
      en: 'Collect the lights of knowledge and unlock the night game'
    },
    days: anitaWeek10Lessons.map(toLegacyDay),
    unlockAfter: { weekId: 'week-9', dayId: 'day-5' }
  }
];

// ---------- Course-aware exports ----------
// Phase 1 of Anita parallel curriculum: keep `WEEKS` as the back-compat
// alias for Max's array, expose `MAX_WEEKS` / `ANITA_WEEKS` explicitly, and
// surface a small `getWeeksForCourse` helper so UI consumers can render the
// right curriculum without leaking Max content into Anita.

// Back-compat: existing imports of `WEEKS` continue to receive Max's array.
export const WEEKS = MAX_WEEKS;

export const WEEKS_BY_COURSE = {
  max: MAX_WEEKS,
  anita: ANITA_WEEKS
};

export const getWeeksForCourse = (courseTemplate = 'max') => {
  if (Object.prototype.hasOwnProperty.call(WEEKS_BY_COURSE, courseTemplate)) {
    return WEEKS_BY_COURSE[courseTemplate];
  }
  return WEEKS_BY_COURSE.max;
};

// ---------- Helpers ----------
export const findDay = (weekId, dayId, weeks = WEEKS) => {
  const week = weeks.find((w) => w.id === weekId);
  if (!week || !week.days) return null;
  return week.days.find((d) => d.id === dayId) || null;
};

export const computeDayStatus = (childProgress, weekId, dayId, weeks = WEEKS) => {
  const week = weeks.find((w) => w.id === weekId);
  if (!week) return 'locked';
  if (week.locked) return 'locked';
  if (!week.days) return 'locked';

  const dayIndex = week.days.findIndex((d) => d.id === dayId);
  if (dayIndex === -1) return 'locked';

  const day = week.days[dayIndex];
  const key = `${weekId}/${dayId}`;
  const record = (childProgress || {})[key];

  if (day.forceLocked) return 'locked';
  if (record?.status === 'completed') return 'completed';

  // Cross-week gating: a week with `unlockAfter` is locked until the
  // referenced day in the prior week is completed.
  if (dayIndex === 0 && week.unlockAfter) {
    const gate = week.unlockAfter;
    const gateRec = (childProgress || {})[`${gate.weekId}/${gate.dayId}`];
    if (gateRec?.status !== 'completed') return 'locked';
  }

  if (dayIndex === 0) {
    return record?.status === 'in_progress' ? 'in_progress' : 'open';
  }

  const prev = week.days[dayIndex - 1];
  const prevRecord = (childProgress || {})[`${weekId}/${prev.id}`];
  if (prevRecord?.status === 'completed') {
    return record?.status === 'in_progress' ? 'in_progress' : 'open';
  }
  return 'locked';
};
